import React from 'react'
import { ShowIf } from '@ztechapps/webui.util'
import type { Address } from '@ztechapps/common.contract'

export const AddressDisplay = ({ value }: { value: Address }) => {
  return (
    <div>
      <ShowIf condition={!!value?.company}>
        <div>{value?.company ?? ''}</div>
      </ShowIf>
      <ShowIf condition={!!value?.name}>
        <div>{value?.name ?? ''}</div>
      </ShowIf>
      <ShowIf condition={!!value?.phone}>
        <div>{value?.phone ?? ''}</div>
      </ShowIf>
      <div>{value?.street1 ?? ''}</div>
      <ShowIf condition={!!value?.street2}>
        <div>{value?.street2 ?? ''}</div>
      </ShowIf>
      <ShowIf condition={!!value?.street3}>
        <div>{value?.street3 ?? ''}</div>
      </ShowIf>
      <div>
        {value?.city ?? ''}, {value?.state ?? ''} {value?.zip ?? ''}
      </div>
      <ShowIf condition={!!value?.country}>
        <div>{value?.country ?? ''}</div>
      </ShowIf>
    </div>
  )
}
